// pdf/logoToBase64.js
export async function logoToBase64(path, targetSize = 64, scale = 3) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    if (path.startsWith("http")) {
      img.crossOrigin = "Anonymous";
    }

    img.onload = () => {
      // Create a larger canvas for high DPI
      const canvas = document.createElement("canvas");
      canvas.width = targetSize * scale;
      canvas.height = targetSize * scale;

      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw image scaled to canvas
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

      // Export at high resolution
      resolve(canvas.toDataURL("image/png"));
    };

    img.onerror = () => reject(new Error(`Failed to load image at ${path}`));
    img.src = path;
  });
}
